import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const createSchema = Yup.object().shape({
  nome: Yup.string().required(mensagemPadrao),
  modalidade: Yup.string().required(mensagemPadrao),
  cargaHoraria: Yup.string().required(mensagemPadrao),
  duracao: Yup.string().required(mensagemPadrao),
  nomeCoordenador: Yup.string().required(mensagemPadrao),
  cpfCoordenador: Yup.string().required(mensagemPadrao),
  titulacaoCoordenador: Yup.string().required(mensagemPadrao),
  area: Yup.string().required(mensagemPadrao)
})
